import { CheckCircleFilled } from "@ant-design/icons";
import "./PartnerFormSucess.scss";

export default function PartnerFormSuccess() {
  return (
    <div className="req-submitted">
      <CheckCircleFilled/>
      <h1>Thank you for your request!</h1>
      <p>We will review your application and respond to the contact email provided in the form within 2-3 business days.</p>
    </div>
  )
}